import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, getOneDriveoAuthAccessTokenRevokeApi } from "../utils/Constants";


export const revokeOneDrivePermissionSlice = createAsyncThunk("revokeOneDrivePermissionSlice", async () => {
    try {
        const token = localStorage.getItem("token");

        const config = {
            headers: { Authorization: token, "Access-Control-Allow-Origin": "*" },
        };
        const response = await axios.get(ApiBaseUrl + getOneDriveoAuthAccessTokenRevokeApi, config);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
});


const revokeOneDrivePermissionSliceSlice = createSlice({
    name: "revokeOneDrivePermissionSliceReducer",

    initialState: {
        isLoading: false,
        data: null,
    },
    reducers: {
        clearrevokeOneDrivePermissionSliceSliceData: (state) => {
            state.data = null;
            state.isAuthenticated = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(revokeOneDrivePermissionSlice.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(revokeOneDrivePermissionSlice.fulfilled, (state, action) => {
                state.isLoading = false;
                state.data = action.payload;
            })
            .addCase(revokeOneDrivePermissionSlice.rejected, (state) => {
                state.isError = false;
            })
    },
});

export const { clearrevokeOneDrivePermissionSliceSliceData } = revokeOneDrivePermissionSliceSlice.actions;
export default revokeOneDrivePermissionSliceSlice.reducer;
